import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close5",
  "use": "icon-close5-usage",
  "viewBox": "0 0 34 34",
  "content": "<symbol viewBox=\"0 0 34 34\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close5\">\n    <circle cx=\"17\" cy=\"17\" r=\"17\" fill=\"#fff\" />\n    <path stroke=\"#FF9F19\" stroke-width=\"1.5\" stroke-linecap=\"round\" d=\"m11.657 21.596 9.546-9.546M12.01 12.05l9.546 9.546\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol